/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TaskAuthenticationKind {
    None = '0',
    All = 1,
    Restricted = 2,
}
